module.exports = __webpack_public_path__ + "static/hero_01-ce805bb3cfa8c53f5c3d5776b3c1a9c3.jpg";